// U1 F11 — este archivo YA NO es una fuente de plantillas en runtime.
// La web consume el catálogo canónico del backend (`/api/stickers/templates`).
// Solo se mantienen las paletas y helpers de RENDERIZADO local.
// DEPRECATED como catálogo: no añadir ni editar plantillas aquí.

// Generado por scripts/gen_sticker_template_i18n.py — NO editar a mano salvo revisión puntual.
export const TEMPLATE_TEXT_I18N = {
  "v1": {
    "en": {
      "title": "Badly Parked?",
      "slogan": "Scan to alert the owner!",
      "subline": "Anonymous & Secure Contact"
    },
    "pt": {
      "title": "Estacionado errado?",
      "slogan": "Escaneie para avisar o dono!",
      "subline": "Contato anônimo e seguro"
    },
    "fr": {
      "title": "Mal garé ?",
      "slogan": "Scannez pour prévenir le propriétaire !",
      "subline": "Contact anonyme et sécurisé"
    }
  },
  "v2": {
    "en": {
      "title": "Car Trouble?",
      "slogan": "Scan and notify the owner",
      "subline": "Anonymous, secure call"
    },
    "pt": {
      "title": "Problemas com seu carro?",
      "slogan": "Escaneie e avise o dono",
      "subline": "Ligue de forma anônima e segura"
    },
    "fr": {
      "title": "Problème avec ta voiture ?",
      "slogan": "Scannez et prévenez le propriétaire",
      "subline": "Appel anonyme et sécurisé"
    }
  },
  "v3": {
    "en": {
      "title": "Parked and in Trouble?",
      "slogan": "Scan to alert the owner",
      "subline": "Secure, anonymous communication"
    },
    "pt": {
      "title": "Estacionado com problema?",
      "slogan": "Escaneie para alertar o proprietário",
      "subline": "Comunicação segura e anônima"
    },
    "fr": {
      "title": "Garé en difficulté ?",
      "slogan": "Scannez pour alerter le propriétaire",
      "subline": "Communication sécurisée et anonyme"
    }
  },
  "v4": {
    "en": {
      "title": "Scan & Alert the Owner!",
      "slogan": "Easy and Anonymous",
      "subline": "Emergency • Private Call"
    },
    "pt": {
      "title": "Escaneie e avise o dono!",
      "slogan": "Fácil e anônimo",
      "subline": "Emergência • Ligação privada"
    },
    "fr": {
      "title": "Scannez et prévenez le propriétaire !",
      "slogan": "Simple et anonyme",
      "subline": "Urgence • Appel privé"
    }
  },
  "v5": {
    "en": {
      "title": "If I’m blocking you, I’m here",
      "slogan": "One scan and done",
      "subline": "Fast response guaranteed"
    },
    "pt": {
      "title": "Se atrapalho, me avise",
      "slogan": "Um scan e pronto",
      "subline": "Resposta rápida garantida"
    },
    "fr": {
      "title": "Si je bloque, je suis là",
      "slogan": "Un scan et c’est parti",
      "subline": "Réponse rapide garantie"
    }
  },
  "v6": {
    "en": {
      "title": "Responsible Driver",
      "slogan": "Instant contact",
      "subline": "Your peace of mind, my promise"
    },
    "pt": {
      "title": "Motorista responsável",
      "slogan": "Contato imediato",
      "subline": "Sua tranquilidade, meu compromisso"
    },
    "fr": {
      "title": "Conducteur responsable",
      "slogan": "Contact immédiat",
      "subline": "Votre tranquillité, mon engagement"
    }
  },
  "v7": {
    "en": {
      "title": "Urgent?",
      "slogan": "Scan here",
      "subline": "Instant notice to the owner"
    },
    "pt": {
      "title": "Urgência?",
      "slogan": "Escaneie aqui",
      "subline": "Aviso instantâneo ao proprietário"
    },
    "fr": {
      "title": "Urgence ?",
      "slogan": "Scannez ici",
      "subline": "Alerte instantanée au propriétaire"
    }
  },
  "v8": {
    "en": {
      "title": "My Car, Your Peace of Mind",
      "slogan": "Secure communication",
      "subline": "Without revealing your number"
    },
    "pt": {
      "title": "Meu carro, sua tranquilidade",
      "slogan": "Comunicação segura",
      "subline": "Sem revelar seu número"
    },
    "fr": {
      "title": "Ma voiture, votre tranquillité",
      "slogan": "Communication sécurisée",
      "subline": "Sans révéler votre numéro"
    }
  },
  "v9": {
    "en": {
      "title": "Parked but Connected",
      "slogan": "Let me know if I’m in the way",
      "subline": "I’ll reply right away"
    },
    "pt": {
      "title": "Estacionado, mas conectado",
      "slogan": "Me avise se eu estiver atrapalhando",
      "subline": "Respondo rapidinho"
    },
    "fr": {
      "title": "Garé mais connecté",
      "slogan": "Prévenez-moi si je gêne",
      "subline": "Je réponds illico"
    }
  },
  "v10": {
    "en": {
      "title": "Always Available",
      "slogan": "Scan and contact",
      "subline": "24/7 • Anonymous • Secure"
    },
    "pt": {
      "title": "Sempre disponível",
      "slogan": "Escaneie e contate",
      "subline": "24/7 • Anônimo • Seguro"
    },
    "fr": {
      "title": "Toujours disponible",
      "slogan": "Scannez et contactez",
      "subline": "24/7 • Anonyme • Sécurisé"
    }
  },
  "o1": {
    "en": {
      "title": "Thanks for taking a second!",
      "slogan": "Scan and let my owner know",
      "subline": "Your help means a lot"
    },
    "pt": {
      "title": "Obrigado por tirar um segundo!",
      "slogan": "Escaneie e avise meu dono",
      "subline": "Sua ajuda vale muito"
    },
    "fr": {
      "title": "Merci de prendre une seconde !",
      "slogan": "Scannez et prévenez mon propriétaire",
      "subline": "Votre aide compte beaucoup"
    }
  },
  "o2": {
    "en": {
      "title": "If it were yours...",
      "slogan": "you’d want it back too",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Se fosse seu...",
      "slogan": "você também ia querer de volta",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "Si c’était le vôtre...",
      "slogan": "vous voudriez aussi qu’on le rende",
      "subline": "Scannez ici"
    }
  },
  "o3": {
    "en": {
      "title": "Oops... I think I was left behind",
      "slogan": "Can you help me?",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Ops... acho que me esqueceram",
      "slogan": "Me ajuda?",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "Oups... je crois qu’on m’a oublié",
      "slogan": "Vous m’aidez ?",
      "subline": "Scannez ici"
    }
  },
  "o4": {
    "en": {
      "title": "Lost but not forgotten",
      "slogan": "Help me get back home",
      "subline": "Reward assured"
    },
    "pt": {
      "title": "Perdido, mas não esquecido",
      "slogan": "Me ajude a voltar pra casa",
      "subline": "Recompensa garantida"
    },
    "fr": {
      "title": "Perdu mais pas oublié",
      "slogan": "Aidez-moi à rentrer à la maison",
      "subline": "Récompense assurée"
    }
  },
  "o5": {
    "en": {
      "title": "My owner misses me",
      "slogan": "Be a hero today",
      "subline": "One scan can make all the difference"
    },
    "pt": {
      "title": "Meu dono sente minha falta",
      "slogan": "Seja um herói hoje",
      "subline": "Um scan pode fazer a diferença"
    },
    "fr": {
      "title": "Mon propriétaire me cherche",
      "slogan": "Soyez un héros aujourd’hui",
      "subline": "Un scan peut tout changer"
    }
  },
  "o6": {
    "en": {
      "title": "Finding me was easy",
      "slogan": "Returning me is too",
      "subline": "Scan and contact"
    },
    "pt": {
      "title": "Me encontrar foi fácil",
      "slogan": "Devolver também",
      "subline": "Escaneie e contate"
    },
    "fr": {
      "title": "Me trouver était facile",
      "slogan": "Me rendre aussi",
      "subline": "Scannez et contactez"
    }
  },
  "o7": {
    "en": {
      "title": "Scan here",
      "slogan": "and be the hero of the day",
      "subline": "Your good deed counts"
    },
    "pt": {
      "title": "Escaneie aqui",
      "slogan": "e seja o herói do dia",
      "subline": "Sua boa ação conta"
    },
    "fr": {
      "title": "Scannez ici",
      "slogan": "et soyez le héros du jour",
      "subline": "Votre bonne action compte"
    }
  },
  "o8": {
    "en": {
      "title": "I matter to someone",
      "slogan": "Help me get back",
      "subline": "Easy, fast contact"
    },
    "pt": {
      "title": "Sou importante para alguém",
      "slogan": "Me ajude a voltar",
      "subline": "Contato fácil e rápido"
    },
    "fr": {
      "title": "Je compte pour quelqu’un",
      "slogan": "Aidez-moi à rentrer",
      "subline": "Contact simple et rapide"
    }
  },
  "o9": {
    "en": {
      "title": "Don’t leave me here",
      "slogan": "Scan and alert",
      "subline": "My owner is waiting for me"
    },
    "pt": {
      "title": "Não me deixe aqui",
      "slogan": "Escaneie e avise",
      "subline": "Meu dono espera por mim"
    },
    "fr": {
      "title": "Ne me laissez pas ici",
      "slogan": "Scannez et prévenez",
      "subline": "Mon propriétaire m’attend"
    }
  },
  "o10": {
    "en": {
      "title": "Reward guaranteed",
      "slogan": "For bringing me home",
      "subline": "Scan for more info"
    },
    "pt": {
      "title": "Recompensa garantida",
      "slogan": "Por me devolver pra casa",
      "subline": "Escaneie para mais info"
    },
    "fr": {
      "title": "Récompense garantie",
      "slogan": "Pour m’avoir ramené à la maison",
      "subline": "Scannez pour plus d’infos"
    }
  },
  "n1": {
    "en": {
      "title": "I’m Protected",
      "slogan": "Just scan and alert",
      "subline": "My parents are nearby"
    },
    "pt": {
      "title": "Estou protegido",
      "slogan": "É só escanear e avisar",
      "subline": "Meus pais estão por perto"
    },
    "fr": {
      "title": "Je suis protégé",
      "slogan": "Scanne et préviens",
      "subline": "Mes parents sont près de moi"
    }
  },
  "n2": {
    "en": {
      "title": "If I get lost, scan here",
      "slogan": "My family is waiting",
      "subline": "Get in touch with my parents"
    },
    "pt": {
      "title": "Se eu me perder, escaneie",
      "slogan": "Minha família me espera",
      "subline": "Contato imediato com meus pais"
    },
    "fr": {
      "title": "Si je me perds, scanne ici",
      "slogan": "Ma famille m’attend",
      "subline": "Contact immédiat avec mes parents"
    }
  },
  "n3": {
    "en": {
      "title": "I’m a protected explorer",
      "slogan": "But sometimes I get lost",
      "subline": "Scan and alert my parents"
    },
    "pt": {
      "title": "Sou um explorador protegido",
      "slogan": "Mas às vezes me perco",
      "subline": "Escaneie e avise meus pais"
    },
    "fr": {
      "title": "Je suis un explorateur protégé",
      "slogan": "Mais je me perds parfois",
      "subline": "Scanne et préviens mes parents"
    }
  },
  "n4": {
    "en": {
      "title": "Small but connected",
      "slogan": "Scan if I need help",
      "subline": "My family gets the alert"
    },
    "pt": {
      "title": "Pequeno, mas conectado",
      "slogan": "Escaneie se eu precisar de ajuda",
      "subline": "Minha família recebe o aviso"
    },
    "fr": {
      "title": "Petit mais connecté",
      "slogan": "Scanne si j’ai besoin d’aide",
      "subline": "Ma famille reçoit l’alerte"
    }
  },
  "n5": {
    "en": {
      "title": "My heroes watch over me",
      "slogan": "But you can help too",
      "subline": "One scan keeps me safe"
    },
    "pt": {
      "title": "Meus heróis cuidam de mim",
      "slogan": "Mas você também pode ajudar",
      "subline": "Um escaneamento me protege"
    },
    "fr": {
      "title": "Mes héros me protègent",
      "slogan": "Mais toi aussi, tu peux aider",
      "subline": "Un scan me protège"
    }
  },
  "n6": {
    "en": {
      "title": "Always safe",
      "slogan": "with AvisoCar",
      "subline": "Scan and my parents will know"
    },
    "pt": {
      "title": "Sempre seguro",
      "slogan": "com AvisoCar",
      "subline": "Escaneie e meus pais sabem"
    },
    "fr": {
      "title": "Toujours en sécurité",
      "slogan": "avec AvisoCar",
      "subline": "Scanne et mes parents le savent"
    }
  },
  "n7": {
    "en": {
      "title": "A little angel protected",
      "slogan": "Help me find Mom",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Um anjinho protegido",
      "slogan": "Me ajude a encontrar a mamãe",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "Un petit ange protégé",
      "slogan": "Aide-moi à retrouver maman",
      "subline": "Scanne ici"
    }
  },
  "n8": {
    "en": {
      "title": "Scan and alert my parents",
      "slogan": "It’s quick and easy",
      "subline": "Thanks for keeping me safe"
    },
    "pt": {
      "title": "Escaneie e avise meus pais",
      "slogan": "É fácil e rápido",
      "subline": "Obrigado por cuidar de mim"
    },
    "fr": {
      "title": "Scanne et préviens mes parents",
      "slogan": "C’est facile et rapide",
      "subline": "Merci de prendre soin de moi"
    }
  },
  "n9": {
    "en": {
      "title": "My family is waiting",
      "slogan": "If you see me lost, scan",
      "subline": "Your help means a lot"
    },
    "pt": {
      "title": "Minha família me espera",
      "slogan": "Se me vir perdido, escaneie",
      "subline": "Sua ajuda é muito importante"
    },
    "fr": {
      "title": "Ma famille m’attend",
      "slogan": "Si tu me vois perdu, scanne",
      "subline": "Ton aide est très importante"
    }
  },
  "n10": {
    "en": {
      "title": "Adventurous but findable",
      "slogan": "My parents know where I am",
      "subline": "Thanks to you and AvisoCar"
    },
    "pt": {
      "title": "Aventureiro, mas localizável",
      "slogan": "Meus pais sabem onde estou",
      "subline": "Graças a você e à AvisoCar"
    },
    "fr": {
      "title": "Aventurier mais retrouvable",
      "slogan": "Mes parents savent où je suis",
      "subline": "Grâce à toi et à AvisoCar"
    }
  },
  "p1": {
    "en": {
      "title": "I’m not lost...",
      "slogan": "just waiting for help",
      "subline": "Scan and alert my human"
    },
    "pt": {
      "title": "Não estou perdido...",
      "slogan": "só esperando ajuda",
      "subline": "Escaneie e avise meu humano"
    },
    "fr": {
      "title": "Je ne suis pas perdu...",
      "slogan": "je patiente juste",
      "subline": "Scanne et préviens mon humain"
    }
  },
  "p2": {
    "en": {
      "title": "My human is looking for me",
      "slogan": "Help me get home",
      "subline": "One scan can save me"
    },
    "pt": {
      "title": "Meu humano me procura",
      "slogan": "Me ajude a voltar",
      "subline": "Um escaneamento me salva"
    },
    "fr": {
      "title": "Mon humain me cherche",
      "slogan": "Aide-moi à rentrer",
      "subline": "Un scan me sauve"
    }
  },
  "p3": {
    "en": {
      "title": "If I travel with you...",
      "slogan": "let my owner know",
      "subline": "Scan this QR"
    },
    "pt": {
      "title": "Se eu viajar com você...",
      "slogan": "avise meu dono",
      "subline": "Escaneie este QR"
    },
    "fr": {
      "title": "Si tu voyages avec moi...",
      "slogan": "préviens mon maître",
      "subline": "Scanne ce QR"
    }
  },
  "p4": {
    "en": {
      "title": "Little paws looking for home",
      "slogan": "My family misses me",
      "subline": "Help me get back"
    },
    "pt": {
      "title": "Patinhas em busca de um lar",
      "slogan": "Minha família sente minha falta",
      "subline": "Me ajude a voltar"
    },
    "fr": {
      "title": "Des pattes qui cherchent un foyer",
      "slogan": "Ma famille me manque",
      "subline": "Aide-moi à rentrer"
    }
  },
  "p5": {
    "en": {
      "title": "I’m a good boy",
      "slogan": "I’m just lost",
      "subline": "Scan and be my hero"
    },
    "pt": {
      "title": "Sou um bom garoto",
      "slogan": "só estou perdido",
      "subline": "Escaneie e seja meu herói"
    },
    "fr": {
      "title": "Je suis un bon chien",
      "slogan": "je suis juste perdu",
      "subline": "Scanne et sois mon héros"
    }
  },
  "p6": {
    "en": {
      "title": "My collar tells my story",
      "slogan": "Scan and learn it",
      "subline": "Help me get back home"
    },
    "pt": {
      "title": "Minha coleira tem minha história",
      "slogan": "Escaneie e conheça",
      "subline": "Me ajude a voltar pra casa"
    },
    "fr": {
      "title": "Mon collier a mon histoire",
      "slogan": "Scanne et découvre-la",
      "subline": "Aide-moi à rentrer"
    }
  },
  "p7": {
    "en": {
      "title": "Woof! You found my QR",
      "slogan": "Let my owner know",
      "subline": "I’ll thank you with licks"
    },
    "pt": {
      "title": "Au! Você achou meu QR",
      "slogan": "Avise meu dono",
      "subline": "Vou agradecer com lambidas"
    },
    "fr": {
      "title": "Wouf ! Tu as trouvé mon QR",
      "slogan": "Préviens mon maître",
      "subline": "Je te remercierai de léchouilles"
    }
  },
  "p8": {
    "en": {
      "title": "A friend is waiting for me",
      "slogan": "Help me find them",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Um amigo espera por mim",
      "slogan": "Me ajude a encontrá-lo",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "Un ami m’attend",
      "slogan": "Aide-moi à le retrouver",
      "subline": "Scanne ici"
    }
  },
  "p9": {
    "en": {
      "title": "I’m not lost, just exploring",
      "slogan": "But my human is worried",
      "subline": "Tell them I’m okay"
    },
    "pt": {
      "title": "Não estou perdido, só explorando",
      "slogan": "Mas meu humano se preocupa",
      "subline": "Avise que estou bem"
    },
    "fr": {
      "title": "Je ne suis pas perdu, j’explore",
      "slogan": "Mais mon humain s’inquiète",
      "subline": "Dis-lui que je vais bien"
    }
  },
  "p10": {
    "en": {
      "title": "Meow? Did you find me?",
      "slogan": "Scan and alert my human",
      "subline": "I promise to behave"
    },
    "pt": {
      "title": "Miau? Você me encontrou?",
      "slogan": "Escaneie e avise meu humano",
      "subline": "Prometo me comportar bem"
    },
    "fr": {
      "title": "Miaou ? Tu m’as trouvé ?",
      "slogan": "Scanne et préviens mon humain",
      "subline": "Promis, je serai sage"
    }
  },
  "t1": {
    "en": {
      "title": "Connected Traveler",
      "slogan": "My bag has an owner",
      "subline": "Scan if you find me"
    },
    "pt": {
      "title": "Viajante conectado",
      "slogan": "Minha mala tem dono",
      "subline": "Escaneie se me encontrar"
    },
    "fr": {
      "title": "Voyageur connecté",
      "slogan": "Ma valise a un propriétaire",
      "subline": "Scanne si tu me trouves"
    }
  },
  "t2": {
    "en": {
      "title": "If I get lost on the trip",
      "slogan": "Scan and contact",
      "subline": "My owner is waiting for me"
    },
    "pt": {
      "title": "Se eu me perder na viagem",
      "slogan": "Escaneie e contate",
      "subline": "Meu dono me espera"
    },
    "fr": {
      "title": "Si je me perds en voyage",
      "slogan": "Scanne et contacte",
      "subline": "Mon propriétaire m’attend"
    }
  },
  "t3": {
    "en": {
      "title": "From the airport to you",
      "slogan": "Help me get home",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Do aeroporto às suas mãos",
      "slogan": "Me ajude a chegar",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "De l’aéroport à tes mains",
      "slogan": "Aide-moi à arriver",
      "subline": "Scanne ici"
    }
  },
  "t4": {
    "en": {
      "title": "Smart luggage",
      "slogan": "Always linked to its owner",
      "subline": "One scan and done"
    },
    "pt": {
      "title": "Bagagem inteligente",
      "slogan": "Sempre ligada ao dono",
      "subline": "Um scan e pronto"
    },
    "fr": {
      "title": "Bagage intelligent",
      "slogan": "Toujours relié à son propriétaire",
      "subline": "Un scan et c’est bon"
    }
  },
  "t5": {
    "en": {
      "title": "Adventurous but trackable",
      "slogan": "My owner knows where I am",
      "subline": "Thanks to AvisoCar"
    },
    "pt": {
      "title": "Aventureiro, mas rastreável",
      "slogan": "Meu dono sabe de mim",
      "subline": "Graças à AvisoCar"
    },
    "fr": {
      "title": "Aventurier mais localisable",
      "slogan": "Mon propriétaire sait où je suis",
      "subline": "Grâce à AvisoCar"
    }
  },
  "t6": {
    "en": {
      "title": "Memories that come home",
      "slogan": "Don’t let them get lost",
      "subline": "Scan if you find me"
    },
    "pt": {
      "title": "Lembranças que voltam pra casa",
      "slogan": "Não deixe se perderem",
      "subline": "Escaneie se me encontrar"
    },
    "fr": {
      "title": "Des souvenirs qui rentrent",
      "slogan": "Ne les laisse pas se perdre",
      "subline": "Scanne si tu me trouves"
    }
  },
  "t7": {
    "en": {
      "title": "Protected backpacker",
      "slogan": "My info is in the QR",
      "subline": "Scan and contact"
    },
    "pt": {
      "title": "Mochileiro protegido",
      "slogan": "Minhas infos estão no QR",
      "subline": "Escaneie e contate"
    },
    "fr": {
      "title": "Sac à dos protégé",
      "slogan": "Mes infos sont dans le QR",
      "subline": "Scanne et contacte"
    }
  },
  "t8": {
    "en": {
      "title": "Responsible tourist",
      "slogan": "My luggage has an identity",
      "subline": "Scan for more info"
    },
    "pt": {
      "title": "Turista responsável",
      "slogan": "Minha bagagem tem identidade",
      "subline": "Escaneie para mais infos"
    },
    "fr": {
      "title": "Touriste responsable",
      "slogan": "Mon bagage a une identité",
      "subline": "Scanne pour plus d’infos"
    }
  },
  "t9": {
    "en": {
      "title": "Passport to peace of mind",
      "slogan": "Your info safe in the QR",
      "subline": "Travel worry-free"
    },
    "pt": {
      "title": "Passaporte para a tranquilidade",
      "slogan": "Suas infos seguras no QR",
      "subline": "Viaje sem preocupações"
    },
    "fr": {
      "title": "Passeport pour la tranquillité",
      "slogan": "Tes infos sûres dans le QR",
      "subline": "Voyage sans souci"
    }
  },
  "t10": {
    "en": {
      "title": "My bag, my identity",
      "slogan": "Scan if you found it",
      "subline": "Thanks for your help"
    },
    "pt": {
      "title": "Minha mala, minha identidade",
      "slogan": "Escaneie se encontrar",
      "subline": "Obrigado pela ajuda"
    },
    "fr": {
      "title": "Ma valise, mon identité",
      "slogan": "Scanne si tu l’as trouvée",
      "subline": "Merci pour ton aide"
    }
  },
  "e1": {
    "en": {
      "title": "IN CASE OF EMERGENCY",
      "slogan": "Scan this code",
      "subline": "Vital medical information"
    },
    "pt": {
      "title": "EM CASO DE EMERGÊNCIA",
      "slogan": "Escaneie este código",
      "subline": "Informações médicas vitais"
    },
    "fr": {
      "title": "EN CAS D’URGENCE",
      "slogan": "Scanne ce code",
      "subline": "Informations médicales vitales"
    }
  },
  "e2": {
    "en": {
      "title": "Vital medical information",
      "slogan": "Quick access in emergencies",
      "subline": "Scan to see my details"
    },
    "pt": {
      "title": "Informações médicas vitais",
      "slogan": "Acesso rápido em emergências",
      "subline": "Escaneie para ver meus dados"
    },
    "fr": {
      "title": "Informations médicales vitales",
      "slogan": "Accès rapide en urgence",
      "subline": "Scanne pour voir mes infos"
    }
  },
  "e3": {
    "en": {
      "title": "Emergency contact here",
      "slogan": "Critical information",
      "subline": "Scan and act fast"
    },
    "pt": {
      "title": "Contato de emergência aqui",
      "slogan": "Informações críticas",
      "subline": "Escaneie e aja rápido"
    },
    "fr": {
      "title": "Contact d’urgence ici",
      "slogan": "Informations critiques",
      "subline": "Scanne et agis vite"
    }
  },
  "e4": {
    "en": {
      "title": "If something happens to me",
      "slogan": "Scan and contact",
      "subline": "My family needs to know"
    },
    "pt": {
      "title": "Se algo me acontecer",
      "slogan": "Escaneie e contate",
      "subline": "Minha família precisa saber"
    },
    "fr": {
      "title": "S’il m’arrive quelque chose",
      "slogan": "Scanne et contacte",
      "subline": "Ma famille doit savoir"
    }
  },
  "e5": {
    "en": {
      "title": "Critical health info",
      "slogan": "Allergies and info",
      "subline": "Scan in an emergency"
    },
    "pt": {
      "title": "Dados críticos de saúde",
      "slogan": "Alergias e informações",
      "subline": "Escaneie em caso de emergência"
    },
    "fr": {
      "title": "Données santé critiques",
      "slogan": "Allergies et infos",
      "subline": "Scanne en cas d’urgence"
    }
  },
  "e6": {
    "en": {
      "title": "Immediate help",
      "slogan": "Scan for information",
      "subline": "Every second counts"
    },
    "pt": {
      "title": "Ajuda imediata",
      "slogan": "Escaneie para informações",
      "subline": "Cada segundo conta"
    },
    "fr": {
      "title": "Aide immédiate",
      "slogan": "Scanne pour infos",
      "subline": "Chaque seconde compte"
    }
  },
  "e7": {
    "en": {
      "title": "My life in one code",
      "slogan": "Information that saves",
      "subline": "Scan and act"
    },
    "pt": {
      "title": "Minha vida em um código",
      "slogan": "Informações que salvam",
      "subline": "Escaneie e aja"
    },
    "fr": {
      "title": "Ma vie en un code",
      "slogan": "Des infos qui sauvent",
      "subline": "Scanne et agis"
    }
  },
  "e8": {
    "en": {
      "title": "Allergies and info",
      "slogan": "Important details",
      "subline": "Scan before acting"
    },
    "pt": {
      "title": "Alergias e informações",
      "slogan": "Dados importantes",
      "subline": "Escaneie antes de agir"
    },
    "fr": {
      "title": "Allergies et infos",
      "slogan": "Données importantes",
      "subline": "Scanne avant d’agir"
    }
  },
  "e9": {
    "en": {
      "title": "First aid",
      "slogan": "Scan for instructions",
      "subline": "Vital information here"
    },
    "pt": {
      "title": "Primeiros socorros",
      "slogan": "Escaneie para instruções",
      "subline": "Informações vitais aqui"
    },
    "fr": {
      "title": "Premiers secours",
      "slogan": "Scanne pour les instructions",
      "subline": "Infos vitales ici"
    }
  },
  "e10": {
    "en": {
      "title": "ICE - In case of emergency",
      "slogan": "Contact my family",
      "subline": "Critical information"
    },
    "pt": {
      "title": "ICE - Em caso de emergência",
      "slogan": "Contate minha família",
      "subline": "Informações críticas"
    },
    "fr": {
      "title": "ICE - En cas d’urgence",
      "slogan": "Contacte ma famille",
      "subline": "Informations critiques"
    }
  },
  "pr1": {
    "en": {
      "title": "You Can Help",
      "slogan": "without seeing my number",
      "subline": "Secure contact with AvisoCar"
    },
    "pt": {
      "title": "Você pode ajudar",
      "slogan": "sem ver meu número",
      "subline": "Contato seguro com AvisoCar"
    },
    "fr": {
      "title": "Tu peux aider",
      "slogan": "sans voir mon numéro",
      "subline": "Contact sécurisé avec AvisoCar"
    }
  },
  "pr2": {
    "en": {
      "title": "Anonymous Communication",
      "slogan": "Your privacy protected",
      "subline": "Contact without revealing your number"
    },
    "pt": {
      "title": "Comunicação anônima",
      "slogan": "Sua privacidade protegida",
      "subline": "Fale sem revelar seu número"
    },
    "fr": {
      "title": "Communication anonyme",
      "slogan": "Votre vie privée protégée",
      "subline": "Contacte sans révéler votre numéro"
    }
  },
  "pr3": {
    "en": {
      "title": "Your Privacy Matters",
      "slogan": "Mine does too",
      "subline": "Safe, anonymous contact"
    },
    "pt": {
      "title": "Sua privacidade importa",
      "slogan": "A minha também",
      "subline": "Contato seguro e anônimo"
    },
    "fr": {
      "title": "Votre vie privée compte",
      "slogan": "La mienne aussi",
      "subline": "Contact sûr et anonyme"
    }
  },
  "pr4": {
    "en": {
      "title": "Notify Me Without Knowing Me",
      "slogan": "100% anonymous contact",
      "subline": "Your info is never shared"
    },
    "pt": {
      "title": "Me avise sem saber quem sou",
      "slogan": "Contato 100% anônimo",
      "subline": "Seu dado não é compartilhado"
    },
    "fr": {
      "title": "Préviens-moi sans savoir qui je suis",
      "slogan": "Contact 100% anonyme",
      "subline": "Vos données ne sont pas partagées"
    }
  },
  "pr5": {
    "en": {
      "title": "Safety First",
      "slogan": "Encrypted data",
      "subline": "Protected communication"
    },
    "pt": {
      "title": "Segurança em primeiro lugar",
      "slogan": "Dados criptografados",
      "subline": "Comunicação protegida"
    },
    "fr": {
      "title": "Sécurité d’abord",
      "slogan": "Données chiffrées",
      "subline": "Communication protégée"
    }
  },
  "pr6": {
    "en": {
      "title": "No Spam, Just Alerts",
      "slogan": "Your peace of mind guaranteed",
      "subline": "Responsible contact"
    },
    "pt": {
      "title": "Sem spam, só avisos",
      "slogan": "Sua tranquilidade garantida",
      "subline": "Contato responsável"
    },
    "fr": {
      "title": "Pas de spam, juste des alertes",
      "slogan": "Votre tranquillité garantie",
      "subline": "Contact responsable"
    }
  },
  "pr7": {
    "en": {
      "title": "Discreet Contact",
      "slogan": "Professional and secure",
      "subline": "Your number stays private"
    },
    "pt": {
      "title": "Contato discreto",
      "slogan": "Profissional e seguro",
      "subline": "Seu número não é revelado"
    },
    "fr": {
      "title": "Contact discret",
      "slogan": "Professionnel et sûr",
      "subline": "Votre numéro n’est pas révélé"
    }
  },
  "pr8": {
    "en": {
      "title": "My Info, My Control",
      "slogan": "You choose what to share",
      "subline": "Privacy guaranteed"
    },
    "pt": {
      "title": "Minha info, meu controle",
      "slogan": "Você decide o que compartilha",
      "subline": "Privacidade garantida"
    },
    "fr": {
      "title": "Mes infos, mon contrôle",
      "slogan": "C’est vous qui décidez quoi partager",
      "subline": "Confidentialité garantie"
    }
  },
  "pr9": {
    "en": {
      "title": "Protected by AvisoCar",
      "slogan": "Secure communication",
      "subline": "Your privacy is our priority"
    },
    "pt": {
      "title": "Protegido por AvisoCar",
      "slogan": "Comunicação segura",
      "subline": "Sua privacidade é nossa prioridade"
    },
    "fr": {
      "title": "Protégé par AvisoCar",
      "slogan": "Communication sécurisée",
      "subline": "Votre vie privée est notre priorité"
    }
  },
  "pr10": {
    "en": {
      "title": "Contact Without Revealing Number",
      "slogan": "Simple, safe, private",
      "subline": "Scan and get in touch"
    },
    "pt": {
      "title": "Contato sem revelar número",
      "slogan": "Simples, seguro, privado",
      "subline": "Escaneie e fale"
    },
    "fr": {
      "title": "Contact sans révéler le numéro",
      "slogan": "Simple, sûr, privé",
      "subline": "Scannez et contactez"
    }
  },
  "c1": {
    "en": {
      "title": "Oops! Did I block you?",
      "slogan": "So sorry",
      "subline": "Scan and let me know"
    },
    "pt": {
      "title": "Ops! Te bloqueei?",
      "slogan": "Mil desculpas",
      "subline": "Escaneie e me avise"
    },
    "fr": {
      "title": "Oups ! Je vous bloque ?",
      "slogan": "Mille excuses",
      "subline": "Scannez et prévenez-moi"
    }
  },
  "c2": {
    "en": {
      "title": "Don’t Be Mad",
      "slogan": "Scan first",
      "subline": "I promise I’ll move the car"
    },
    "pt": {
      "title": "Não fique bravo",
      "slogan": "Escaneie primeiro",
      "subline": "Prometo mover o carro"
    },
    "fr": {
      "title": "Ne vous fâchez pas",
      "slogan": "Scannez d’abord",
      "subline": "Je promets de déplacer la voiture"
    }
  },
  "c3": {
    "en": {
      "title": "Instant Karma",
      "slogan": "Help me, and it hits",
      "subline": "Scan here"
    },
    "pt": {
      "title": "Karma instantâneo",
      "slogan": "Se me ajudar, ele chega",
      "subline": "Escaneie aqui"
    },
    "fr": {
      "title": "Karma instantané",
      "slogan": "Si vous m’aidez, ça revient",
      "subline": "Scannez ici"
    }
  },
  "c4": {
    "en": {
      "title": "My Car, My Responsibility",
      "slogan": "Let me know if I’m in the way",
      "subline": "I’m a good neighbor"
    },
    "pt": {
      "title": "Meu carro, minha responsabilidade",
      "slogan": "Me avise se estiver atrapalhando",
      "subline": "Sou um bom vizinho"
    },
    "fr": {
      "title": "Ma voiture, ma responsabilité",
      "slogan": "Prévenez-moi si je gêne",
      "subline": "Je suis un bon voisin"
    }
  },
  "c5": {
    "en": {
      "title": "Friendly Neighbor",
      "slogan": "Beginner mistake",
      "subline": "But responsible"
    },
    "pt": {
      "title": "Vizinho amigável",
      "slogan": "Erro de iniciante",
      "subline": "Mas responsável"
    },
    "fr": {
      "title": "Voisin sympa",
      "slogan": "Erreur de débutant",
      "subline": "Mais responsable"
    }
  },
  "c6": {
    "en": {
      "title": "Parking level: Expert",
      "slogan": "Well... almost",
      "subline": "Scan if I messed up"
    },
    "pt": {
      "title": "Parking nível: Expert",
      "slogan": "Bom... quase",
      "subline": "Escaneie se eu errei"
    },
    "fr": {
      "title": "Parking level : Expert",
      "slogan": "Enfin... presque",
      "subline": "Scannez si j’ai raté"
    }
  },
  "c7": {
    "en": {
      "title": "I Parked As Best I Could",
      "slogan": "Don’t judge me",
      "subline": "Scan if I’m in the way"
    },
    "pt": {
      "title": "Estacionei como deu",
      "slogan": "Não me julgue",
      "subline": "Escaneie se atrapalhei"
    },
    "fr": {
      "title": "Je me suis garé comme j’ai pu",
      "slogan": "Ne me jugez pas",
      "subline": "Scannez si je gêne"
    }
  },
  "c8": {
    "en": {
      "title": "Sorry for Blocking You",
      "slogan": "It was an accident",
      "subline": "Let me know and I’ll fix it"
    },
    "pt": {
      "title": "Desculpa pelo bloqueio",
      "slogan": "Foi sem querer",
      "subline": "Me avise e resolvo"
    },
    "fr": {
      "title": "Pardon pour le blocage",
      "slogan": "C’était sans vouloir",
      "subline": "Prévenez-moi et je règle ça"
    }
  },
  "c9": {
    "en": {
      "title": "Best Neighbor in the Lot",
      "slogan": "Or at least I try",
      "subline": "Scan if I didn’t make it"
    },
    "pt": {
      "title": "O melhor vizinho do estacionamento",
      "slogan": "Ou pelo menos tento",
      "subline": "Escaneie se eu não consegui"
    },
    "fr": {
      "title": "Le meilleur voisin du parking",
      "slogan": "Ou du moins j’essaie",
      "subline": "Scannez si je n’ai pas réussi"
    }
  },
  "c10": {
    "en": {
      "title": "Plot Twist: I’m Responsible",
      "slogan": "Scan and see",
      "subline": "I’ll reply right away"
    },
    "pt": {
      "title": "Plot twist: Sou responsável",
      "slogan": "Escaneie e veja",
      "subline": "Te respondo rapidinho"
    },
    "fr": {
      "title": "Plot twist : je suis responsable",
      "slogan": "Scannez et vous verrez",
      "subline": "Je vous réponds vite"
    }
  },
  "m1": {
    "en": {
      "title": "Scan",
      "slogan": "Contact",
      "subline": ""
    },
    "pt": {
      "title": "Escaneie",
      "slogan": "Contato",
      "subline": ""
    },
    "fr": {
      "title": "Scanne",
      "slogan": "Contacte",
      "subline": ""
    }
  },
  "m2": {
    "en": {
      "title": "Contact",
      "slogan": "Scan here",
      "subline": ""
    },
    "pt": {
      "title": "Contato",
      "slogan": "Escaneie aqui",
      "subline": ""
    },
    "fr": {
      "title": "Contact",
      "slogan": "Scannez ici",
      "subline": ""
    }
  },
  "m3": {
    "en": {
      "title": "AvisoCar",
      "slogan": "",
      "subline": ""
    },
    "pt": {
      "title": "AvisoCar",
      "slogan": "",
      "subline": ""
    },
    "fr": {
      "title": "AvisoCar",
      "slogan": "",
      "subline": ""
    }
  },
  "m4": {
    "en": {
      "title": "Let Me Know",
      "slogan": "",
      "subline": ""
    },
    "pt": {
      "title": "Avise-me",
      "slogan": "",
      "subline": ""
    },
    "fr": {
      "title": "Préviens-moi",
      "slogan": "",
      "subline": ""
    }
  },
  "m5": {
    "en": {
      "title": "QR",
      "slogan": "Scan",
      "subline": ""
    },
    "pt": {
      "title": "QR",
      "slogan": "Escaneie",
      "subline": ""
    },
    "fr": {
      "title": "QR",
      "slogan": "Scanne",
      "subline": ""
    }
  },
  "m6": {
    "en": {
      "title": "→",
      "slogan": "Scan",
      "subline": ""
    },
    "pt": {
      "title": "→",
      "slogan": "Scan",
      "subline": ""
    },
    "fr": {
      "title": "→",
      "slogan": "Scan",
      "subline": ""
    }
  },
  "m7": {
    "en": {
      "title": "Info",
      "slogan": "Scan",
      "subline": ""
    },
    "pt": {
      "title": "Info",
      "slogan": "Escaneie",
      "subline": ""
    },
    "fr": {
      "title": "Info",
      "slogan": "Scanne",
      "subline": ""
    }
  },
  "m8": {
    "en": {
      "title": "Scan",
      "slogan": "",
      "subline": ""
    },
    "pt": {
      "title": "Scan",
      "slogan": "",
      "subline": ""
    },
    "fr": {
      "title": "Scan",
      "slogan": "",
      "subline": ""
    }
  },
  "m9": {
    "en": {
      "title": ".",
      "slogan": "",
      "subline": ""
    },
    "pt": {
      "title": ".",
      "slogan": "",
      "subline": ""
    },
    "fr": {
      "title": ".",
      "slogan": "",
      "subline": ""
    }
  },
  "m10": {
    "en": {
      "title": "AC",
      "slogan": "",
      "subline": ""
    },
    "pt": {
      "title": "AC",
      "slogan": "",
      "subline": ""
    },
    "fr": {
      "title": "AC",
      "slogan": "",
      "subline": ""
    }
  },
  "l1": {
    "en": {
      "title": "Hey, let me know!",
      "slogan": "If I block your car",
      "subline": "We help each other here"
    },
    "pt": {
      "title": "Parceiro, me avise!",
      "slogan": "Se eu bloquear seu carro",
      "subline": "Entre peruanos, a gente se ajuda"
    },
    "fr": {
      "title": "Pote, préviens-moi !",
      "slogan": "Si je bloque ta voiture",
      "subline": "Entre Péruviens, on s’entraide"
    }
  },
  "l2": {
    "en": {
      "title": "Among Peruvians",
      "slogan": "we help each other",
      "subline": "Scan and contact safely"
    },
    "pt": {
      "title": "Entre peruanos",
      "slogan": "a gente se ajuda",
      "subline": "Escaneie e fale com segurança"
    },
    "fr": {
      "title": "Entre Péruviens",
      "slogan": "on s’entraide",
      "subline": "Scanne et contacte en toute sécurité"
    }
  },
  "l3": {
    "en": {
      "title": "Buddy, just scan here",
      "slogan": "I’ll reply right away",
      "subline": "Peruvian promise"
    },
    "pt": {
      "title": "Parceiro, escaneie aqui",
      "slogan": "Respondo na hora",
      "subline": "Palavra de peruano"
    },
    "fr": {
      "title": "Pote, scanne ici",
      "slogan": "Je te réponds vite",
      "subline": "Parole de Péruvien"
    }
  },
  "l4": {
    "en": {
      "title": "So you don’t get mad",
      "slogan": "Scan and let me know",
      "subline": "I’ll fix it right away"
    },
    "pt": {
      "title": "Pra não te irritar",
      "slogan": "Escaneie e me avise",
      "subline": "Resolvo rapidinho"
    },
    "fr": {
      "title": "Pour ne pas râler",
      "slogan": "Scanne et préviens-moi",
      "subline": "Je règle ça vite"
    }
  },
  "l5": {
    "en": {
      "title": "Work done right",
      "slogan": "I’m responsible with my car",
      "subline": "Scan if you need anything"
    },
    "pt": {
      "title": "Trampo bem feito",
      "slogan": "Sou responsável com meu carro",
      "subline": "Escaneie se precisar de algo"
    },
    "fr": {
      "title": "Boulot bien fait",
      "slogan": "Je suis responsable de ma voiture",
      "subline": "Scanne si besoin"
    }
  },
  "l6": {
    "en": {
      "title": "I’ll let you know ASAP",
      "slogan": "Just scan",
      "subline": "Fast as ceviche"
    },
    "pt": {
      "title": "Te aviso na hora",
      "slogan": "É só escanear",
      "subline": "Rapidinho como ceviche"
    },
    "fr": {
      "title": "Je te préviens vite",
      "slogan": "Scanne juste",
      "subline": "Rapide comme un ceviche"
    }
  },
  "l7": {
    "en": {
      "title": "Good vibes always",
      "slogan": "Scan and let’s talk",
      "subline": "No worries, buddy"
    },
    "pt": {
      "title": "Boa onda sempre",
      "slogan": "Escaneie e conversamos",
      "subline": "Sem problemas, parceiro"
    },
    "fr": {
      "title": "Toujours cool",
      "slogan": "Scanne et on parle",
      "subline": "Pas de souci, pote"
    }
  },
  "l8": {
    "en": {
      "title": "I’ll contact you for sure",
      "slogan": "Word of honor",
      "subline": "Just scan"
    },
    "pt": {
      "title": "Pode crer, te contato",
      "slogan": "Palavra de honra",
      "subline": "É só escanear"
    },
    "fr": {
      "title": "Je te contacte, c’est sûr",
      "slogan": "Parole d’honneur",
      "subline": "Scanne juste"
    }
  },
  "l9": {
    "en": {
      "title": "Cool and secure",
      "slogan": "That’s how contact works",
      "subline": "By AvisoCar"
    },
    "pt": {
      "title": "Bacana e seguro",
      "slogan": "Assim é o contato",
      "subline": "Via AvisoCar"
    },
    "fr": {
      "title": "Sympa et sûr",
      "slogan": "C’est ça, le contact",
      "subline": "Via AvisoCar"
    }
  },
  "l10": {
    "en": {
      "title": "Made in Peru",
      "slogan": "with lots of love",
      "subline": "AvisoCar 💚"
    },
    "pt": {
      "title": "Feito no Peru",
      "slogan": "com muito carinho",
      "subline": "AvisoCar 💚"
    },
    "fr": {
      "title": "Fabriqué au Pérou",
      "slogan": "avec beaucoup d’amour",
      "subline": "AvisoCar 💚"
    }
  }
};

export const localizeTemplate = (tpl, lang) => {
  if (!tpl || !lang || lang === "es") return tpl;
  const tr = TEMPLATE_TEXT_I18N[tpl.id]?.[lang];
  if (!tr) return tpl;
  return { ...tpl, title: tr.title || tpl.title, slogan: tr.slogan || tpl.slogan, subline: tr.subline || tpl.subline };
};
